import { render, staticRenderFns } from "./NotesList.vue?vue&type=template&id=abc70200&scoped=true"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"
import style0 from "./NotesList.vue?vue&type=style&index=0&id=abc70200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc70200",
  null
  
)

export default component.exports